import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  private isLoading = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoading.asObservable();

  private isLoadingApp = new BehaviorSubject<boolean>(true);
  isLoadingApp$ = this.isLoadingApp.asObservable();

  constructor() { }

  valideOrderNumber(orderNumber: string) {
    if (orderNumber.length >= 5 && orderNumber.length <= 35) return true;
    else return false;
  }

  setLoadingStatus(status: boolean){
    this.isLoading.next(status);
  }

  setLoadingStatusApp(status: boolean){
    this.isLoadingApp.next(status);
  }
}
